import { render, staticRenderFns } from "./VeJwJingsaiCheckGroupModal.vue?vue&type=template&id=8bc87208"
import script from "./VeJwJingsaiCheckGroupModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiCheckGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports